import styled from 'styled-components/macro';
import images from '~/constants/images';
import { Button } from '~/components';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: ${({ theme }) => theme.white};
  height: 100%;
  width: 100%;
`;

export const Background = styled.div`
  position: absolute;
  z-index: 0;
  width: 100%;
  height: 100%;
  background-image: url(${images.notFoundBackground});
  opacity: 0.2;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top center;
`;

export const BeatDecoration = styled.div`
  position: absolute;
  ${({ inverted }) => (inverted ? 'bottom:0;' : 'top:0;')};
  left: 0;
  width: 100%;
  height: 50px;
  background-image: url(${images.beat});
  background-size: 100%;
  background-position: center 44%;
  opacity: 0.25;
  transform-origin: center;
  transform: rotate(${({ inverted }) => (inverted ? 180 : 0)}deg);

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}px) {
    background-size: 250%;
    background-position: center 44%;
    height: 25px;
  }
`;

export const Logo = styled.img`
  height: 90px;

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}px) {
    height: 75px;
  }
`;

export const BigMessage = styled.p`
  font-size: ${({ theme }) => theme.h1 * 2}px;
  margin: 15px;
  color: ${({ theme }) => theme.dark};
`;

export const Title = styled.p`
  font-size: ${({ theme }) => theme.h2}px;
  margin-bottom: 25px;
  font-family: ${({ theme }) => theme.primaryFontBold};
  text-transform: uppercase;
  color: ${({ theme }) => theme.dark};
`;

export const Message = styled.p`
  font-size: ${({ theme }) => theme.h5}px;
  color: ${({ theme }) => theme.dark};
`;

export const NavigationButton = styled(Button)`
  border: none;
  padding: 10px 50px;
  margin-top: 25px;
  font-size: ${({ theme }) => theme.h4}px;
  text-transform: uppercase;
  background-color: ${({ theme }) => theme.dark};
  z-index: 1;
  color: ${({ theme }) => theme.white};

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}px) {
    max-width: 90%;
  }

  a {
    color: ${({ theme }) => theme.white};
  }
`;
